import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-28 px-6 lg:px-12 bg-white border-t border-[#e8e2da]">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-[11px] font-light tracking-[0.35em] uppercase text-greige mb-6">
          Begin Your Journey
        </p>
        <h2 className="text-4xl md:text-5xl font-light text-charcoal tracking-tight mb-5">
          Join the Club
        </h2>
        <div className="w-16 h-px bg-gold mx-auto mb-8"></div>
        <p className="text-greige text-base font-light leading-relaxed mb-12 max-w-xl mx-auto">
          Experience elevated hydration with priority booking, personalized treatments, and exclusive wellness perks. Your journey to optimal vitality begins here.
        </p>
        <Link
          to="/book"
          className="inline-block px-12 py-3.5 bg-charcoal text-white text-[11px] font-light tracking-[0.2em] uppercase hover:bg-charcoal/80 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Book Now
        </Link>
        <p className="text-greige text-xs font-light mt-10 tracking-widest uppercase">
          Los Angeles, CA &nbsp;·&nbsp; Licensed RNs &nbsp;·&nbsp; Private Suites
        </p>
      </div>
    </section>
  );
}
